import downloadDocument from "../services/downloadDocument";

const useDownloadDocument = () => {
  return {
    download: async (documentId: string) => downloadDocument(documentId),
  };
};

export default useDownloadDocument;
